(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["props-gallery"] && !Shopify.designMode) return;
  try {
    
(function() {
  const init = (container) => {
    const id = container.getAttribute('data-section-id');
    if (!id) return;

    const grid = document.getElementById('props-gallery-grid-' + id);
    const dotsContainer = document.getElementById('props-gallery-dots-' + id);
    if (!grid || !dotsContainer) return;

    const dots = dotsContainer.querySelectorAll('.props-gallery-dot');
    let scrollTimeout;

    const updateDots = () => {
      if (!dots.length) return;
      const itemWidth = grid.scrollWidth / dots.length;
      const activeIndex = Math.min(
        dots.length - 1,
        Math.max(0, Math.round(grid.scrollLeft / itemWidth))
      );
      dots.forEach(dot => dot.classList.remove('active'));
      if (dots[activeIndex]) dots[activeIndex].classList.add('active');
    };

    grid.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateDots, 30);
    });

    updateDots();

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const items = grid.querySelectorAll('.props-gallery-item');
        if (items[index]) {
          items[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });
  };

  document.querySelectorAll('[data-section-type="props-gallery"]').forEach(init);

  document.addEventListener('shopify:section:load', (e) => {
    const container = e.target.querySelector('[data-section-type="props-gallery"]');
    if (container) init(container);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["props-logo-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var init = function (container) {
    var id = container.getAttribute('data-section-id');
    if (!id) return;

    if (container._propsMarqueeCleanup) container._propsMarqueeCleanup();

    var logosWrapper = container.querySelector('.props-logo-marquee-logos');
    var track = container.querySelector('.props-logo-marquee-track');
    if (!track) return;

    var speedDesktop = parseFloat(container.getAttribute('data-speed')) || 50;
    var speedMobile = parseFloat(container.getAttribute('data-speed-mobile')) || 35;
    var direction = container.getAttribute('data-direction') || 'left';
    var reverseMobile = container.getAttribute('data-reverse-mobile') === 'true';
    var draggable = container.getAttribute('data-draggable') === 'true';
    var pauseOnHover = container.getAttribute('data-pause-on-hover') === 'true';

    var offset = 0;
    var rafId = null;
    var lastTime = 0;
    var hovering = false;
    var isDragging = false;

    var getSpeed = function () {
      return window.innerWidth < 750 ? speedMobile : speedDesktop;
    };

    var getDirection = function () {
      if (window.innerWidth < 750 && reverseMobile) {
        return direction === 'left' ? 'right' : 'left';
      }
      return direction;
    };

    var halfWidth = function () {
      return track.scrollWidth / 2;
    };

    var wrapOffset = function () {
      var hw = halfWidth();
      if (hw > 0) {
        offset = offset % hw;
        if (offset > 0) offset -= hw;
      }
    };

    var tick = function (now) {
      if (reducedMotion.matches || isDragging || hovering) {
        lastTime = 0;
        rafId = requestAnimationFrame(tick);
        return;
      }

      if (!lastTime) {
        lastTime = now;
        rafId = requestAnimationFrame(tick);
        return;
      }

      var dt = (now - lastTime) / 1000;
      lastTime = now;
      if (dt > 0.1) dt = 0.1;

      var speed = getSpeed();
      var dir = getDirection();

      if (dir === 'left') {
        offset -= speed * dt;
      } else {
        offset += speed * dt;
      }

      wrapOffset();
      track.style.transform = 'translateX(' + offset + 'px)';
      rafId = requestAnimationFrame(tick);
    };

    rafId = requestAnimationFrame(tick);

    var hoverTarget = logosWrapper || container;

    if (pauseOnHover) {
      hoverTarget.addEventListener('mouseenter', function () { hovering = true; });
      hoverTarget.addEventListener('mouseleave', function () { hovering = false; lastTime = 0; });
    }

    if (draggable && hoverTarget) {
      var startX = 0;
      var dragStartOffset = 0;

      var onStart = function (e) {
        isDragging = true;
        hoverTarget.classList.add('is-dragging');
        startX = e.touches ? e.touches[0].clientX : e.clientX;
        dragStartOffset = offset;
      };

      var onMove = function (e) {
        if (!isDragging) return;
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        offset = dragStartOffset + (x - startX);
        wrapOffset();
        track.style.transform = 'translateX(' + offset + 'px)';
      };

      var onEnd = function () {
        if (!isDragging) return;
        isDragging = false;
        hoverTarget.classList.remove('is-dragging');
        lastTime = 0;
      };

      hoverTarget.addEventListener('mousedown', onStart);
      hoverTarget.addEventListener('mousemove', onMove);
      hoverTarget.addEventListener('mouseup', onEnd);
      hoverTarget.addEventListener('mouseleave', function () {
        if (isDragging) onEnd();
      });

      hoverTarget.addEventListener('touchstart', onStart, { passive: true });
      hoverTarget.addEventListener('touchmove', onMove, { passive: true });
      hoverTarget.addEventListener('touchend', onEnd);
    }

    container._propsMarqueeCleanup = function () {
      cancelAnimationFrame(rafId);
    };
  };

  document.querySelectorAll('[data-section-type="props-logo-marquee"]').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    var c = e.target.querySelector('[data-section-type="props-logo-marquee"]');
    if (c) init(c);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["props-slider-gallery"] && !Shopify.designMode) return;
  try {
    
(function() {
  const init = (container) => {
    const id = container.getAttribute('data-section-id');
    if (!id) return;

    const slider = document.getElementById('Slider-' + id);
    const nextBtn = document.getElementById('Next-' + id);
    const prevBtn = document.getElementById('Prev-' + id);
    const dots = document.querySelectorAll('#Dots-' + id + ' .props-slider-gallery-dot');

    if (!slider) return;

    const getItemStep = () => {
      const gap = parseInt(getComputedStyle(slider).getPropertyValue('gap') || 0);
      const item = slider.querySelector('.props-slider-gallery-item');
      return item ? item.offsetWidth + gap : 0;
    };

    const updateUI = () => {
      const step = getItemStep();
      if (!step) return;
      const index = Math.round(slider.scrollLeft / step);
      dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
    };

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const step = getItemStep();
        if (step) slider.scrollBy({ left: step, behavior: 'smooth' });
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        const step = getItemStep();
        if (step) slider.scrollBy({ left: -step, behavior: 'smooth' });
      });
    }

    let scrollTimeout;
    slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateUI, 30);
    });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const step = getItemStep();
        if (step) slider.scrollTo({ left: i * step, behavior: 'smooth' });
      });
    });
  };

  document.querySelectorAll('[data-section-type="props-slider-gallery"]').forEach(init);

  document.addEventListener('shopify:section:load', (e) => {
    const container = e.target.querySelector('[data-section-type="props-slider-gallery"]');
    if (container) init(container);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["props-ticker"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var init = function (container) {
    var id = container.getAttribute('data-section-id');
    if (!id) return;

    if (container._propsTickerCleanup) container._propsTickerCleanup();

    var track = container.querySelector('.props-ticker-track');
    if (!track) return;

    var speedDesktop = parseFloat(container.getAttribute('data-speed')) || 50;
    var speedMobile = parseFloat(container.getAttribute('data-speed-mobile')) || 35;
    var direction = container.getAttribute('data-direction') || 'left';
    var reverseMobile = container.getAttribute('data-reverse-mobile') === 'true';
    var draggable = container.getAttribute('data-draggable') === 'true';
    var pauseOnHover = container.getAttribute('data-pause-on-hover') === 'true';

    var offset = 0;
    var rafId = null;
    var lastTime = 0;
    var hovering = false;
    var isDragging = false;

    var getSpeed = function () {
      return window.innerWidth < 750 ? speedMobile : speedDesktop;
    };

    var getDirection = function () {
      if (window.innerWidth < 750 && reverseMobile) {
        return direction === 'left' ? 'right' : 'left';
      }
      return direction;
    };

    var halfWidth = function () {
      return track.scrollWidth / 2;
    };

    var wrapOffset = function () {
      var hw = halfWidth();
      if (hw > 0) {
        offset = offset % hw;
        if (offset > 0) offset -= hw;
      }
    };

    var tick = function (now) {
      if (reducedMotion.matches || isDragging || hovering) {
        lastTime = 0;
        rafId = requestAnimationFrame(tick);
        return;
      }

      if (!lastTime) {
        lastTime = now;
        rafId = requestAnimationFrame(tick);
        return;
      }

      var dt = (now - lastTime) / 1000;
      lastTime = now;
      if (dt > 0.1) dt = 0.1;

      var speed = getSpeed();
      var dir = getDirection();

      if (dir === 'left') {
        offset -= speed * dt;
      } else {
        offset += speed * dt;
      }

      wrapOffset();
      track.style.transform = 'translateX(' + offset + 'px)';
      rafId = requestAnimationFrame(tick);
    };

    rafId = requestAnimationFrame(tick);

    if (pauseOnHover) {
      container.addEventListener('mouseenter', function () { hovering = true; });
      container.addEventListener('mouseleave', function () { hovering = false; lastTime = 0; });
    }

    if (draggable) {
      var startX = 0;
      var dragStartOffset = 0;

      var onStart = function (e) {
        isDragging = true;
        container.classList.add('is-dragging');
        startX = e.touches ? e.touches[0].clientX : e.clientX;
        dragStartOffset = offset;
      };

      var onMove = function (e) {
        if (!isDragging) return;
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        offset = dragStartOffset + (x - startX);
        wrapOffset();
        track.style.transform = 'translateX(' + offset + 'px)';
      };

      var onEnd = function () {
        if (!isDragging) return;
        isDragging = false;
        container.classList.remove('is-dragging');
        lastTime = 0;
      };

      container.addEventListener('mousedown', onStart);
      container.addEventListener('mousemove', onMove);
      container.addEventListener('mouseup', onEnd);
      container.addEventListener('mouseleave', function () {
        if (isDragging) onEnd();
      });

      container.addEventListener('touchstart', onStart, { passive: true });
      container.addEventListener('touchmove', onMove, { passive: true });
      container.addEventListener('touchend', onEnd);
    }

    container._propsTickerCleanup = function () {
      cancelAnimationFrame(rafId);
    };
  };

  document.querySelectorAll('[data-section-type="props-ticker"]').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    var c = e.target.querySelector('[data-section-type="props-ticker"]');
    if (c) init(c);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
